import styled, { css } from 'styled-components';

import FrontShopLink from 'ggApp/shared/containers/FrontshopLink';
import NewIcon from 'ggApp/shared/icons/New';
import DiscountIcon from 'ggApp/shared/icons/Discount';
import TrendingIcon from 'ggApp/shared/icons/Trending';
import B2BIcon from 'ggApp/shared/icons/B2B';
import B2CIcon from 'ggApp/shared/icons/B2C';

const iconStyles = css`
    width: 24px;
    height: 24px;
    margin-right: 16px;
    position: relative;
`;

export const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors["Level 1"]};
`;

export const Link = styled(FrontShopLink)`
    position: relative;
    min-height: 48px;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.Foreground};
    padding: 0 16px;
    transition: color 0.5s cubic-bezier(0.4, 0, 1, 1);

    &:hover,
    &:active,
    &:focus {
        color: ${({ theme }) => theme.colors.Foreground};
    }
`;

export const Background = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0.15;
    margin-left: -16px;
    transition: background 0.5s cubic-bezier(0.4, 0, 1, 1);
    background: ${({ theme }) => theme.colors.Background};
    &:hover,
    &:active,
    &:focus {
        background: ${({ theme }) => theme.colors.Background};
    }
`;

export const New = styled(NewIcon)`
    ${iconStyles}
`;

export const Discount = styled(DiscountIcon)`
    ${iconStyles}
`;

export const Trending = styled(TrendingIcon)`
    ${iconStyles}
`;

export const B2B = styled(B2BIcon)`
    ${iconStyles}
`;

export const B2C = styled(B2CIcon)`
    ${iconStyles}
`;
